import React, { useEffect, useState } from 'react';

import { UserAgent, ExternalLinks } from '@mirinae/js-utils';

import MobileStoreBanner from '@mirinae/explorer/components/common/MobileStoreBanner';
import { Event } from '@mirinae/explorer/modules/apis/GA3';
import Localization from '@mirinae/shared/il8n';

const MobileStoreBannerContainer = ({ isApp }) => {
    const agreed = sessionStorage.getItem('agreeweb');
    const [display, setDisplay] = useState(false);
    const { os } = UserAgent;

    // isApp can turn true after mount: detection races the Flutter bridge and the appVersion
    // message (see appBase.js), so at mount we may still wrongly believe we are on the web.
    // With [] deps this timer captured that stale value and fired two seconds later regardless,
    // which is how a Play Store banner came to be shown to people already inside the app.
    // Depending on isApp means a late correction cancels the pending timer instead.
    useEffect(() => {
        if (isApp) return undefined;
        const timer = setTimeout(() => {
            if (!isApp
                && (os.isAndroid || os.isIos)
                && agreed !== 'true'
                && !window.location.pathname.match(/account-confirmed/)
                // nothing in either repo sets this class, so this guard protects nothing today
                && document.querySelector('body').classList.value.indexOf('inApp') === -1
            ) {
                setDisplay(true);
            }
        }, 2000);
        return () => clearTimeout(timer);
    }, [isApp]);

    const handleDeny = () => {
        sessionStorage.setItem('agreeweb', 'true');
    };

    return (
        display && !isApp ? (
            <MobileStoreBanner
                linkText={Localization.formatString(Localization['ab-text2'], os.isAndroid ? 'Play' : 'App')}
                ignoreText={Localization['ab-text3']}
                link={os.isAndroid ? ExternalLinks.app.android : ExternalLinks.app.apple}
                onConfirm={() => Event('Banner', 'App Banner on Index page', isApp ? 'app' : 'web')}
                onCancel={handleDeny}
                theme="forWeb"
            >
                {Localization['ab-text1']}
            </MobileStoreBanner>
        ) : null
    );
};

export default MobileStoreBannerContainer;